import { Navigate, useParams } from 'react-router';
import { useAngemeldeterNutzer } from '../auth/auth-context.js';
import { ErrorState, LoadingState } from '../ui/states.js';
import { BilderFreigabePage } from './bilder-freigabe-page.js';
import { istFremd } from './einsicht.js';
import { FreigabePage, type FreigabeSeiteProps } from './freigabe-page.js';
import { useAuftrag } from './use-runs.js';

/**
 * Eine Adresse fuer jede Freigabe (`/auftraege/:id/freigabe`), auch die der Mail aus dem Backend.
 * Welche Seite dahinter steht, entscheidet der Typ: Bilder haben keinen Text, also weder
 * Textflaeche noch Anmerkungen noch Zwischenstand -- eine eigene, schlanke Seite statt Weichen
 * quer durch `FreigabePage`.
 */
export function FreigabeRoute(props: FreigabeSeiteProps) {
  const { runId = '' } = useParams();
  const zustand = useAuftrag(props.quelle, runId);
  const uid = useAngemeldeterNutzer()?.uid ?? null;
  if (zustand.art === 'laedt') return <LoadingState text="Auftrag wird geladen …" />;
  if (zustand.art === 'fehler') {
    return <ErrorState text={zustand.text} onWiederholen={zustand.wiederholen} />;
  }
  // Ein fremder Auftrag (Gesamtansicht der Rolle `admin`) wird nicht freigegeben, sondern gelesen:
  // Die Freigabeseite speichert beim Tippen Entwuerfe und schickte Entscheidungen, die das Backend
  // abweist. Die Ergebnisseite zeigt denselben Zwischenstand ohne Bedienelemente.
  if (zustand.auftrag && istFremd(zustand.auftrag, uid)) {
    return <Navigate to={`/auftraege/${encodeURIComponent(runId)}/ergebnis`} replace />;
  }
  if (zustand.auftrag?.typ === 'bilder') {
    return <BilderFreigabePage quelle={props.quelle} holen={props.holen} senden={props.senden} />;
  }
  return <FreigabePage {...props} />;
}
